import React, { Component } from 'react';
import './AgGridTooltipComponent.css';

export default class TooltipComponent extends Component {
  // eslint-disable-next-line class-methods-use-this
  getReactContainerClasses() {
    return ['custom-tooltip'];
  }

  render() {
    const { data } = this.props.api.getDisplayedRowAtIndex(this.props.rowIndex);
    return (
      <div className="custom-tooltip" style={{ backgroundColor: this.props.color || 'white' }}>
        <div className="custom-tooltip-description">
          <p>
            <span>{data.description}</span>
          </p>
        </div>
      </div>
    );
  }
}
